module.exports = __webpack_public_path__ + "static/media/calendar-outline.738ebc09.svg";